const apeCategories = [
  {
    "title": "SORT",
    "options": [
      {
        "label": "Ascending Token #",
        "value": "ascending"
      },
      {
        "label": "Descending Token #",
        "value": "descending"
      }
    ]
  },
  {
    "title": "background",
    "options": [
      {
        "label": "Charcoal",
        "value": "charcoal"
      },
      {
        "label": "Cherry",
        "value": "cherry"
      },
      {
        "label": "Dark Blue",
        "value": "dark_blue"
      },
      {
        "label": "Gold",
        "value": "gold"
      },
      {
        "label": "Gray",
        "value": "gray"
      },
      {
        "label": "Green",
        "value": "green"
      },
      {
        "label": "Jungle",
        "value": "jungle"
      },
      {
        "label": "Light Blue",
        "value": "light_blue"
      },
      {
        "label": "Lime",
        "value": "lime"
      },
      {
        "label": "Orange",
        "value": "orange"
      },
      {
        "label": "Purple",
        "value": "purple"
      },
      {
        "label": "Red",
        "value": "red"
      },
      {
        "label": "Rose",
        "value": "rose"
      },
      {
        "label": "Violet",
        "value": "violet"
      },
      {
        "label": "White",
        "value": "white"
      },
      {
        "label": "Yellow",
        "value": "yellow"
      }
    ]
  },
  {
    "title": "clothes",
    "options": [
      {
        "label": "3 piece Suit With Vest",
        "value": "3_piece_suit_with_vest"
      },
      {
        "label": "Astronaut Outfit",
        "value": "astronaut_outfit"
      },
      {
        "label": "Bling Cross",
        "value": "bling_cross"
      },
      {
        "label": "Donald Trump Suit",
        "value": "donald_trump_suit"
      },
      {
        "label": "Double breasted Suit",
        "value": "double_breasted_suit"
      },
      {
        "label": "James Bond Suit",
        "value": "james_bond_suit"
      },
      {
        "label": "King Suit",
        "value": "king_suit"
      },
      {
        "label": "Naked",
        "value": "naked"
      },
      {
        "label": "Noble Suit",
        "value": "noble_suit"
      },
      {
        "label": "Pink Shirt Blue Suit",
        "value": "pink_shirt_blue_suit"
      },
      {
        "label": "Pinstripe Suit",
        "value": "pinstripe_suit"
      },
      {
        "label": "Plaid Pattern Suit",
        "value": "plaid_pattern_suit"
      },
      {
        "label": "Sport Coat",
        "value": "sport_coat"
      },
      {
        "label": "Standard 2 piece Suit",
        "value": "standard_2_piece_suit"
      },
      {
        "label": "Tie and Pocket Square",
        "value": "tie_and_pocket_square"
      },
      {
        "label": "Tuxedo",
        "value": "tuxedo"
      },
      {
        "label": "Tweed Suit",
        "value": "tweed_suit"
      }
    ]
  },
  {
    "title": "eyes",
    "options": [
      {
        "label": "3D Glasses",
        "value": "3d_glasses"
      },
      {
        "label": "Angry",
        "value": "angry"
      },
      {
        "label": "Aviators",
        "value": "aviators"
      },
      {
        "label": "Base Eyes",
        "value": "base_eyes"
      },
      {
        "label": "Classic Rayban",
        "value": "classic_rayban"
      },
      {
        "label": "Crazy",
        "value": "crazy"
      },
      {
        "label": "Cyborg Eye",
        "value": "cyborg_eye"
      },
      {
        "label": "Eye Mask",
        "value": "eye_mask"
      },
      {
        "label": "Laser Eyes",
        "value": "laser_eyes"
      },
      {
        "label": "Money Eyes",
        "value": "money_eyes"
      },
      {
        "label": "Monocle",
        "value": "monocle"
      },
      {
        "label": "Sleepy",
        "value": "sleepy"
      },
      {
        "label": "Sunglasses",
        "value": "sunglasses"
      },
      {
        "label": "Surprised",
        "value": "surprised"
      },
      {
        "label": "The Tortoiseshell Glasses",
        "value": "the_tortoiseshell_glasses"
      },
      {
        "label": "Thick Resin Style Eyeglasses",
        "value": "thick_resin_style_eyeglasses"
      },
      {
        "label": "Zombie Eyes",
        "value": "zombie_eyes"
      }
    ]
  },
  {
    "title": "head",
    "options": [
      {
        "label": "Bald",
        "value": "bald"
      },
      {
        "label": "Ball Cap",
        "value": "ball_cap"
      },
      {
        "label": "Base Lion",
        "value": "base_lion"
      },
      {
        "label": "Beanie",
        "value": "beanie"
      },
      {
        "label": "Brown Hair",
        "value": "brown_hair"
      },
      {
        "label": "Deer",
        "value": "deer"
      },
      {
        "label": "Detective",
        "value": "detective"
      },
      {
        "label": "Driving Cap",
        "value": "driving_cap"
      },
      {
        "label": "Elvis Hairstyle",
        "value": "elvis_hairstyle"
      },
      {
        "label": "Fedora",
        "value": "fedora"
      },
      {
        "label": "Fire",
        "value": "fire"
      },
      {
        "label": "King Crown",
        "value": "king_crown"
      },
      {
        "label": "Long Braids",
        "value": "long_braids"
      },
      {
        "label": "Native Headdress",
        "value": "native_headdress"
      },
      {
        "label": "Stetson",
        "value": "stetson"
      },
      {
        "label": "Top Hat",
        "value": "top_hat"
      },
      {
        "label": "Viking",
        "value": "viking"
      },
      {
        "label": "White Hair",
        "value": "white_hair"
      }
    ]
  },
  {
    "title": "mouth",
    "options": [
      {
        "label": "Big Smile",
        "value": "big_smile"
      },
      {
        "label": "Biting Lip",
        "value": "biting_lip"
      },
      {
        "label": "Bubble Gum",
        "value": "bubble_gum"
      },
      {
        "label": "Cigar",
        "value": "cigar"
      },
      {
        "label": "Gold Smile",
        "value": "gold_smile"
      },
      {
        "label": "Grin",
        "value": "grin"
      },
      {
        "label": "Licking Nose",
        "value": "licking_nose"
      },
      {
        "label": "OH",
        "value": "oh"
      },
      {
        "label": "Roaring",
        "value": "roaring"
      },
      {
        "label": "Serious",
        "value": "serious"
      },
      {
        "label": "Smile",
        "value": "smile"
      },
      {
        "label": "Smirk",
        "value": "smirk"
      },
      {
        "label": "Surprised",
        "value": "surprised"
      },
      {
        "label": "Tobacco Pipe",
        "value": "tobacco_pipe"
      },
      {
        "label": "Tongue Out",
        "value": "tongue_out"
      },
      {
        "label": "Toothpick",
        "value": "toothpick"
      },
      {
        "label": "Yelling",
        "value": "yelling"
      }
    ]
  },
  {
    "title": "skin",
    "options": [
      {
        "label": "Black",
        "value": "black"
      },
      {
        "label": "Brown",
        "value": "brown"
      },
      {
        "label": "Cream",
        "value": "cream"
      },
      {
        "label": "Galaxy",
        "value": "galaxy"
      },
      {
        "label": "Golden",
        "value": "golden"
      },
      {
        "label": "Grey",
        "value": "grey"
      },
      {
        "label": "Leopard",
        "value": "leopard"
      },
      {
        "label": "Lizard Blue",
        "value": "lizard_blue"
      },
      {
        "label": "Pink",
        "value": "pink"
      },
      {
        "label": "Rainbow",
        "value": "rainbow"
      },
      {
        "label": "Red",
        "value": "red"
      },
      {
        "label": "Scratched Up",
        "value": "scratched_up"
      },
      {
        "label": "Silver",
        "value": "silver"
      },
      {
        "label": "Spots",
        "value": "spots"
      },
      {
        "label": "Tan",
        "value": "tan"
      },
      {
        "label": "White",
        "value": "white"
      },
      {
        "label": "Zebra",
        "value": "zebra"
      }
    ]
  }
];

export default apeCategories;